export default __webpack_public_path__ + "static/media/botty-checking-no-issues.dcb4c4b0.svg";